export default "__VITE_ASSET__BdEXh0FM__"